import styled from 'styled-components';

export const StyledRank = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    text-align: center;
  }
`;

export const StyledIconRank = styled.div<{
  $fontSize?: number;
  $topPosition?: string;
}>`
  position: absolute;
  top: ${({ $topPosition }) => $topPosition ?? '14%'};
  font-size: ${({ $fontSize }) => `${$fontSize ?? 14}px`};
`;

export const Wrapper = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const StyledPlaceholder = styled.div`
  color: var(--text-soft);
  font-size: 18px;
`;
